import { authConstants } from './../constants/auth-constants';
import paymentMethodsService from './../services/payment-methods.service.js';


export const listAdminPayments = (data) => async (dispatch) => {
    try {
      const res = await paymentMethodsService.getAdminPaymentMethods();

        dispatch({
        type: authConstants.PAYMENT_METHOD_LIST,
        payload: res.data,
      });

  
      return Promise.resolve(res.data);
    } catch (err) {
      console.log(err)
      return Promise.reject(err);
    }
  };